import { ConfigPermissionRoleView as PermissionRole } from './PermissionRole';

export default PermissionRole ;